// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0ce065d4] .el-tabs__header {\n  margin: 0px !important;\n}\n[data-v-0ce065d4] .el-tabs__content {\n  padding-top: 15px !important;\n}\n.tip-warn[data-v-0ce065d4] {\n  width: 500px;\n  margin: 0px auto;\n  position: absolute;\n  left: 30%;\n  top: 1px;\n  z-index: 999;\n}\n", ""]);
// Exports
module.exports = exports;
